"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _misc = require("HubStyleTokens/misc");

var _sizes = require("HubStyleTokens/sizes");

var _theme = require("HubStyleTokens/theme");

var _times = require("HubStyleTokens/times");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIScrollContainer = _interopRequireDefault(require("../scroll/UIScrollContainer"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

var _Styles = require("../utils/Styles");

var TableScrollContainer = (0, _styledComponents.default)(_UIScrollContainer.default).withConfig({
  displayName: "UITable__TableScrollContainer",
  componentId: "h0uzdr-0"
})(["height:", ";"], function (_ref) {
  var scrollDirection = _ref.scrollDirection;
  return scrollDirection === 'both' && '100%';
});

var Table = _styledComponents.default.table.withConfig({
  displayName: "UITable__Table",
  componentId: "h0uzdr-1"
})(["font-size:", ";background-color:", ";border-collapse:collapse;width:100%;", ";th,td{border-color:", ";border-style:solid;border-width:1px 0 0;line-height:normal;vertical-align:middle;}thead{th{", ";font-size:", ";background-color:", ";color:", ";height:", ";padding-bottom:", ";padding-left:", ";padding-right:", ";padding-top:", ";text-align:left;text-transform:uppercase;vertical-align:", ";}}tfoot{td,th{", ";height:", ";padding:", " ", ";text-align:left;}}tbody{td{hyphens:auto;height:", ";overflow-wrap:break-word;padding:", " ", ";vertical-align:", ";.private-tag--inline{vertical-align:", ";}}}", ";", ";", ";", ";.private-card &{border:0;border-radius:inherit;thead{th,.private-table-sort-toggle{background-color:transparent;border-top:0;}}}.private-panel__body &{", ";}"], _sizes.TABLE_DEFAULT_FONT_SIZE, _theme.TABLE_BACKGROUND_COLOR, function (props) {
  return (props.flush || props.responsive) && "&& { margin-bottom: 0; }";
}, _theme.TABLE_BORDER_COLOR, _Styles.FONT_FAMILIES.medium, _sizes.TABLE_HEADER_FONT_SIZE, _theme.TABLE_HEADER_BACKGROUND_COLOR, _theme.BASE_FONT_COLOR, _sizes.TABLE_HEADER_HEIGHT, _sizes.TABLE_HEADER_PADDING_BOTTOM, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_HEADER_PADDING_TOP, _misc.TABLE_HEADER_VERTICAL_ALIGNMENT, _Styles.FONT_FAMILIES.demibold, _sizes.TABLE_CELL_HEIGHT, _sizes.TABLE_DEFAULT_PADDING_Y, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_CELL_HEIGHT, _sizes.TABLE_DEFAULT_PADDING_Y, _sizes.TABLE_DEFAULT_PADDING_X, _misc.TABLE_CELL_VERTICAL_ALIGNMENT, _misc.TABLE_CELL_VERTICAL_ALIGNMENT, function (props) {
  return props.bordered !== false && "\n      border-color: " + _theme.TABLE_BORDER_COLOR + ";\n      border-style: solid;\n      border-width: 0 1px 1px;\n  ";
}, function (props) {
  return props.condensed && "\n      thead th {\n        height: " + _sizes.TABLE_HEADER_HEIGHT + ";\n        padding-bottom: " + _sizes.TABLE_COMPACT_PADDING_Y + ";\n        padding-top: " + _sizes.TABLE_COMPACT_PADDING_Y + "\n      }\n\n      tbody {\n        td, th {\n          height: " + _sizes.TABLE_COMPACT_CELL_HEIGHT + ";\n          padding-bottom: " + _sizes.TABLE_COMPACT_PADDING_Y + ";\n          padding-top: " + _sizes.TABLE_COMPACT_PADDING_Y + ";\n        }\n      }\n  ";
}, function (props) {
  return props.hover && "\n      tbody {\n        tr {\n          transition: background-color " + _times.MICRO_TRANSITION_TIMING + " ease-out;\n        }\n        tr:hover {\n          background-color: " + _theme.TABLE_ROW_HOVER_BACKGROUND_COLOR + ";\n        }\n      }\n  ";
}, function (props) {
  return props.truncated && "\n      table-layout: fixed;\n\n      td,\n      th {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n  ";
}, function (props) {
  return props.bordered !== true && "border-width: 0 0 1px;";
});

var UITable = (0, _react.forwardRef)(function (props, ref) {
  var bordered = props.bordered,
      children = props.children,
      className = props.className,
      condensed = props.condensed,
      flush = props.flush,
      height = props.height,
      hover = props.hover,
      responsive = props.responsive,
      responsiveWrapperClassName = props.responsiveWrapperClassName,
      ScrollContainer = props.ScrollContainer,
      truncated = props.truncated,
      rest = (0, _objectWithoutProperties2.default)(props, ["bordered", "children", "className", "condensed", "flush", "height", "hover", "responsive", "responsiveWrapperClassName", "ScrollContainer", "truncated"]);
  var computedClassName = (0, _classnames.default)('table private-table', className, bordered && 'table-bordered', condensed && 'table-condensed private-table--condensed');

  var renderedTable = _react.default.createElement(Table, Object.assign({}, rest, {
    className: computedClassName,
    bordered: bordered,
    condensed: condensed,
    flush: flush,
    hover: hover,
    ref: ref,
    responsive: responsive,
    truncated: truncated
  }), children);

  return responsive ? _react.default.createElement(_UISection.default, {
    className: (0, _classnames.default)("table-responsive private-scroll__wrapper--tables", responsiveWrapperClassName),
    flush: flush,
    height: height
  }, _react.default.createElement(ScrollContainer, {
    scrollDirection: height != null ? 'both' : 'horizontal'
  }, renderedTable)) : renderedTable;
});
UITable.propTypes = {
  bordered: _propTypes.default.oneOf([true, false, 'auto']),
  children: _propTypes.default.node.isRequired,
  condensed: _propTypes.default.bool.isRequired,
  flush: _propTypes.default.bool.isRequired,
  height: _UISection.default.propTypes.height,
  hover: _propTypes.default.bool.isRequired,
  responsive: _propTypes.default.bool.isRequired,
  responsiveWrapperClassName: _propTypes.default.string,
  ScrollContainer: _propTypes.default.elementType.isRequired,
  truncated: _propTypes.default.bool.isRequired
};
UITable.defaultProps = {
  bordered: 'auto',
  condensed: false,
  flush: false,
  hover: true,
  responsive: true,
  ScrollContainer: TableScrollContainer,
  truncated: false
};
UITable.displayName = 'UITable';
var _default = UITable;
exports.default = _default;
module.exports = exports.default;